import { useState } from "react"
import Pagination from "./Pagination";


export default function OrderHistoryList({ orders }) {

    const [ searchQuery, setSearchQuery ] = useState('')

    // pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [dataPerPage] = useState(9)

    const indexOfLastData = currentPage * dataPerPage
    const indexOfFirstData = indexOfLastData - dataPerPage
    const currentTableDatas = orders.slice(indexOfFirstData, indexOfLastData)

    const paginate = pg => {
        setCurrentPage(pg)
    }

    let table

    if(searchQuery){
        table = orders
    } else {
        table = currentTableDatas
    }

    
    const renderList = table.filter((val) => {
        return val._id.toLowerCase().includes(searchQuery.toLowerCase()) 
                    || val.createdAt.toLowerCase().includes(searchQuery.toLowerCase())
                    || val.status.toLowerCase().includes(searchQuery.toLowerCase())
    }).map((OH, index) => {
        
        const { _id, createdAt, pickAddress, dropAddress, fareAmount, status } = OH
        Date.longMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const d = new Date(createdAt)
        const time = d.toLocaleString('en-Us', { hour: 'numeric', minute: 'numeric', hour12: true })
        const date = Date.longMonths[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear()
        let txtColor

        if (status === "on going" || status === "pending") {
            txtColor = "text-warning"            
        } else if (status === "complete") {
            txtColor = "text-success" 
        } else {
            txtColor = "text-danger"
        }

        return (
            <tr key={index}>
                <td title={_id}>{_id.substring(0, 7) + '...'}</td>
                <td>{time}</td>
                <td>{date}</td>
                <td>{pickAddress}</td>
                <td>{dropAddress}</td>
                <td><span className="fw-bold">&#8358;</span> {fareAmount}</td>
                <td className={txtColor+" tstatus"}>{status}</td>
            </tr>
        )

    })


    return (
        <section>
            {/* search */}
            <div>
                <div className="input form-control w-40 py-0 my-1 me-5">
                    <i className="ri-search-line ri-lg pe-2"></i>
                    <input type="text" placeholder="Search By Order ID, Date or Status" className="w-75 p-2 ps-0" value={searchQuery} onChange={(e) => {setSearchQuery(e.target.value)}} />
                </div>
            </div>
            

            {/* table */}
            <div className="table-responsive my-4">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Time</th>
                            <th>Date</th>
                            <th>Pick-up Address</th>
                            <th>Drop-off Address</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {renderList}
                    </tbody>
                </table>

            </div>
            <Pagination 
            paginate={paginate} 
            dataPerPage={dataPerPage} 
            totalData={orders?.length}
            curPage={currentPage}
            pageLen={currentTableDatas?.length} />
        </section>
    )
}